document.addEventListener('DOMContentLoaded', function() {
  const prevBtn = document.querySelector('.js-related-collection-slide__button-previous');
  const nextBtn = document.querySelector('.js-related-collection-slide__button-next');

  const buttonEvents = function() {
    const carousel = document.querySelector('.js-related-collection-slide__slide'); //Getting the up-to-date carousel size
    const carouselItem = document.querySelector('.js-related-collection-slide__slide-card');
    if (!carousel || !carouselItem) return;
    const carouselItemWidth = carouselItem.offsetWidth;

    prevBtn.addEventListener('click', function() {
      carousel.scrollTo({
        left: carousel.scrollLeft - carouselItemWidth,
        behavior: 'smooth'
      });
    });
  
    nextBtn.addEventListener('click', function() {
      carousel.scrollTo({
        left: carousel.scrollLeft + carouselItemWidth,
        behavior: 'smooth'
      });
    });
  };
  buttonEvents();

  const carouselEvent = function() {
    const carousel = document.querySelector('.js-related-collection-slide__slide'); //Getting the up-to-date carousel size
    if (!carousel) return;
    const carouselWidth = carousel.clientWidth;
    const carouselSrcollWidth = carousel.scrollWidth;
    if (carouselWidth < carouselSrcollWidth) {
      nextBtn.style.display = 'flex';
      const scrollThreshold = 1; //The compensation value for triggering the event
      carousel.addEventListener('scroll', function() {
        if (carousel.scrollLeft <= 0) {
          prevBtn.style.display = 'none';
        } else if (carousel.scrollLeft + carousel.clientWidth + scrollThreshold >= carousel.scrollWidth){
          nextBtn.style.display = 'none';
        } else {
          prevBtn.style.display !== 'flex'? prevBtn.style.display = 'flex' : null;
          nextBtn.style.display !== 'flex'? nextBtn.style.display = 'flex' : null;
        }
      });
    } else {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    };
  };
  carouselEvent();

  window.addEventListener("resize", function() {
    buttonEvents();
    carouselEvent();
  });
});